import { FONTS } from "../constants/theme";

// ─── MODULE PILL ──────────────────────────────────────────────────────────────
// A single module card used in the marketing site's platform grid.
// Displays the module icon, colored label, and description.
//
// Usage:
//   <ModulePill module={MODULES[0]} />

export default function ModulePill({ module: m }) {
  return (
    <div
      className="mod-pill"
      style={{ borderColor: m.accent + "22" }}
      onMouseEnter={(e) => (e.currentTarget.style.borderColor = m.accent + "55")}
      onMouseLeave={(e) => (e.currentTarget.style.borderColor = m.accent + "22")}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
        <div
          style={{
            width: 32,
            height: 32,
            borderRadius: 8,
            background: m.accent + "18",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 14,
            color: m.accent,
          }}
        >
          {m.icon}
        </div>
        <span
          style={{
            fontFamily: FONTS.display,
            fontWeight: 700,
            fontSize: 14,
            color: m.accent,
          }}
        >
          {m.label}
        </span>
      </div>
      <p style={{ fontSize: 12, color: "#8892b0", lineHeight: 1.6 }}>{m.desc}</p>
    </div>
  );
}
